export const styles = {
    container: {},
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
